import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { AlertTriangle, Settings, ExternalLink } from 'lucide-react';

/**
 * AIKeyRequiredDialog - Shows when user tries to use AI features without an API key
 */
const AIKeyRequiredDialog = ({ open, onOpenChange }) => {
  const navigate = useNavigate();

  const handleGoToSettings = () => {
    onOpenChange(false);
    navigate('/company/instellingen?tab=ai');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-orange-600">
            <AlertTriangle className="w-5 h-5" />
            OpenAI API Key Vereist
          </DialogTitle>
          <DialogDescription className="text-left pt-2">
            Om AI functies te gebruiken moet je eerst je eigen OpenAI API key configureren.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
            <h4 className="font-medium text-orange-800 mb-2">Waarom een eigen API key?</h4>
            <ul className="text-sm text-orange-700 space-y-1 list-disc list-inside">
              <li>Je betaalt alleen voor wat je gebruikt</li>
              <li>Je behoudt volledige controle over je kosten</li>
              <li>Je kunt kiezen welk AI model je wilt gebruiken</li>
            </ul>
          </div>
          
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
            <h4 className="font-medium text-gray-800 mb-2">Hoe krijg ik een API key?</h4>
            <ol className="text-sm text-gray-600 space-y-1 list-decimal list-inside">
              <li>Ga naar platform.openai.com</li>
              <li>Maak een account of log in</li>
              <li>Ga naar API Keys en maak een nieuwe key</li>
              <li>Kopieer de key en voer deze in bij Instellingen</li>
            </ol>
          </div>
        </div>

        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={() => window.open('https://platform.openai.com/api-keys', '_blank')}
            className="w-full sm:w-auto"
          >
            <ExternalLink className="w-4 h-4 mr-2" />
            OpenAI Platform
          </Button>
          <Button
            onClick={handleGoToSettings}
            className="w-full sm:w-auto bg-orange-600 hover:bg-orange-700"
            data-testid="go-to-settings-btn"
          >
            <Settings className="w-4 h-4 mr-2" />
            Naar Instellingen
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AIKeyRequiredDialog;
